import React from "react"

import FTPServer from "../../../../components/Motion_Detection/Videos/video-ftp-server-setup"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import Footer from "../../../../components/Layout/footer"

const seodata = {
  title: 'Filezilla FTP Server Setup',
  description: 'If you want to use your Windows PC as FTP backup server for your camera´s alarm recordings, you can use the free program Filezilla.',
  image: '/images/Search/MD_SearchThumb_FTPServerSetup.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
    <h1 id="introduction" style={{ marginTop: 0 }}>
      Filezilla FTP Server erstellen
    </h1>
    <FTPServer />
    <br />
    <br />
    <Footer
      previousTitle="Motion Detection"
      previousLink="/fr/Motion_Detection/"
      nextTitle="FTP Server Setup"
      nextLink="/fr/Motion_Detection/FTP_Server_Setup/" />
  </React.Fragment>
)